import { DealerConsoleAction, FlagStateType, GameType } from './app-enums.model';
import { ChatMessageEvent } from './app-events.model';
import { Json } from '../types.model';
import { CardsChanged } from './result-change.model';

export enum DealerRequestType {
    DealerAction = 'dealer-action',
    GetChatMessages = 'get-chat-messages',
    SetFlagState = 'set-flag-state',
    GetAvailableGames = 'get-available-games',
    ChangeGame = 'change-game',
    ResultChange = 'result-change',
    ConfirmResult = 'confirm-result'
}

export interface DealerActionRequestMessage extends Json {
    action: DealerConsoleAction;
}

export interface SetFlagStateRequestMessage extends Json {
    flag: FlagStateType;
    state: boolean;
}

export interface GetChatMessagesResponseMessage extends Json {
    messages: ChatMessageEvent[];
}

export interface ChangeGameRequestMessage extends Json {
    game: GameType;
}

export interface ChangeGameResponseMessage extends Json {
    selectedGameType: GameType;
}

export interface GetGamesResponseMessage extends Json {
    games: GameType[];
}

export interface ResultChangeRequestMessage extends Json {
    cards: CardsChanged;
}

export interface ConfirmResultRequestMessage extends Json {
    data: boolean;
}
